// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2tnma","fileDisabled":"File_fileDisabled__3ZVIo"};